import { defaultMaxId, PointCloudInfo } from '@abyss/3d-viewer';
import { useCallback, useMemo, useState } from 'react';

export type MaxIdByAttribuite = { [key: string]: number };

export function usePointCloudInfo() {
  const [info, setInfo] = useState<PointCloudInfo>();

  const onOctreeHierarchyLoaded = useCallback(
    (info: PointCloudInfo) => {
      // console.log('onOctreeHierarchyLoaded', { info });
      setInfo(info);
    },
    [setInfo]
  );

  const [hasRgb, maxIds] = useMemo(() => {
    if (!info) return [];
    let hasRgb0 = false;
    const maxIds0: MaxIdByAttribuite = {};
    info.dataFormat.fields.forEach((field) => {
      if (field.name === 'color') {
        hasRgb0 = true;
      } else if (!(field.name in ['x', 'y', 'z'])) {
        maxIds0[field.name] = field.maxId ?? defaultMaxId;
      }
    });
    return [hasRgb0, maxIds0];
  }, [info]);

  return { maxIds, info, hasRgb, onOctreeHierarchyLoaded };
}
